<div class="lum-modal lum-c-sales-order-pull-notifications">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      notification?.data?.title
    }}</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="row">
      <div class="col-12">
        <div class="lum-c-sales-order-pull-notifications__notification">
          <table class="lum-table striped border">
            <tbody>
              <ng-container
                *ngFor="let channel of notification?.data?.channels | keyvalue"
              >
                <tr>
                  <th
                    class="
                      lum-c-sales-order-pull-notifications__channel flex align-items-start
                    "
                  >
                    {{ channel.key }}
                  </th>
                  <td>
                    <div class="flex flex-column order-status--container">
                      <ng-container
                        *ngIf="
                          !(channel.value?.new_order_numbers | isArray) &&
                            (channel.value?.new_order_numbers | objectToArray)
                              .length > 0;
                          else showEmptyNewOrders
                        "
                      >
                        <p>
                          <b>New orders pulled:</b>
                        </p>
                        <ng-container
                          *ngFor="
                            let status of channel.value?.new_order_numbers
                              | keyvalue;
                            trackBy: trackByValue
                          "
                        >
                          <div
                            class="
                              lum-c-sales-order-pull-notifications__status flex flex-row mb-2 pl-5
                            "
                          >
                            <span
                              class="lum-c-sales-order-pull-notifications__status-key w-45 shrink-0"
                              >{{ status.key }} Orders ({{
                                status.value.length
                              }})</span
                            >
                            <span
                              class="lum-c-sales-order-pull-notifications__status-values"
                              >{{ (status.value || []).join(', ') }}</span
                            >
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-template #showEmptyNewOrders>
                        <p>No new orders pulled.</p>
                      </ng-template>

                      <ng-container
                        *ngIf="
                          !(channel.value?.recent_order_numbers | isArray) &&
                            (channel.value?.recent_order_numbers | objectToArray)
                              .length > 0;
                          else showEmptyRecentOrders
                        "
                      >
                        <p>
                          <b>Recent pulled orders:</b>
                        </p>
                        <ng-container
                          *ngFor="
                            let status of channel.value?.recent_order_numbers
                              | keyvalue;
                            trackBy: trackByValue
                          "
                        >
                          <div
                            class="
                              lum-c-sales-order-pull-notifications__status flex flex-row mb-2 pl-5
                            "
                          >
                            <span
                              class="lum-c-sales-order-pull-notifications__status-key w-45 shrink-0"
                              >{{ status.key }} Orders ({{
                                status.value.length
                              }})</span
                            >
                            <span
                              class="lum-c-sales-order-pull-notifications__status-values"
                              >{{ (status.value || []).join(', ') }}</span
                            >
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-template #showEmptyRecentOrders>
                        <p>No recently orders pulled.</p>
                      </ng-template>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
